/**
 * 값이 null 또는 undefined가 아닌지 확인합니다.
 *
 * @param value 검사할 값
 * @returns 값이 null 또는 undefined가 아니면 true를 반환합니다.
 */
export function isNotNull<T>(value: unknown): value is NonNullable<T> {
  return value != null;
}
